<template>
  <div class="login-wrap p-4 p-md-5">
    <h1>Página não encontrada</h1>
    <p>Desculpe, a página que você está procurando não existe.</p>
    <a href="/admin/">Voltar para a página inicial</a>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  name: 'NotFoundPage',
  data() {
    return {
    
    };
  },
  computed: {
    ...mapGetters(['config'])
  },
  mounted() {
  
  },
  methods: {
    
  }
}
</script>

<style scoped>
.login-wrap {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 34px 0 rgba(0, 0, 0, 0.1);
  padding: 30px;
}

.icon {
  margin-bottom: 20px;
}

.icon span {
  font-size: 60px;
  color: #333;
}

h3 {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

button {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background: #007bff;
  color: #fff;
  cursor: pointer;
}

button:hover {
  background: #0056b3;
}
</style>
